module.exports = __webpack_public_path__ + "static/FoundersGrotesk-RegularItalic-eaab85693f547000444829dc7081a1f1.woff";